/**
 * EU withdrawal floating trigger + bottom-right stack.
 * When the withdraw chip is present (Sweden/Ireland), bottom → top:
 * - Promo/salon teaser (bottommost; desktop: beside withdraw)
 * - Withdraw
 * - BXGY above withdraw
 * Mobile may also tuck a forms tease under the promo row.
 */
(function () {
  var MOBILE_MAX = 749;
  var GAP_REM = 0.8;

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function hasWithdraw() {
    return !!document.querySelector('.eu-withdrawal-popup__trigger');
  }

  function formsEl() {
    return document.getElementById('app-embed') || document.querySelector('[data-form-root="true"]');
  }

  function formsIsTease(el) {
    return el ? el.dataset.currentStep === 'tease' : false;
  }

  function bxgyEl() {
    var el = document.getElementById('bxgy-offer-root');
    if (!el) return null;
    /* Only stack the bottom-corner floater, not a centered full modal. */
    if (el.classList.contains('bxgy-modal--center')) return null;
    if (el.hasAttribute('hidden')) return null;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return null;
    return el;
  }

  function visiblePromoTeaser() {
    return document.querySelector('.promo-teaser[data-state="visible"]');
  }

  function visibleSalonTeaser() {
    return document.querySelector('.salon-locator-teaser[data-state="visible"]');
  }

  function isSalonTeaser(el) {
    return !!(el && el.classList && el.classList.contains('salon-locator-teaser'));
  }

  function rootFontPx() {
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
  }

  function baseInsetPx() {
    var probe = document.createElement('div');
    probe.style.position = 'fixed';
    probe.style.bottom = 'var(--floating-action-inset, 2.4rem)';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    document.body.appendChild(probe);
    var value = parseFloat(getComputedStyle(probe).bottom) || 16;
    document.body.removeChild(probe);
    return value;
  }

  function gapPx() {
    return rootFontPx() * GAP_REM;
  }

  function heightOf(el) {
    if (!el) return 0;
    var rect = el.getBoundingClientRect();
    return rect.height > 0 ? rect.height : 0;
  }

  function widthOf(el) {
    if (!el) return 0;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 ? rect.width : 0;
  }

  /** CSS `right` so el's right edge sits `gap` px left of target's left edge. */
  function rightBesideLeftOf(target) {
    var rect = target.getBoundingClientRect();
    return Math.max(0, window.innerWidth - rect.left + gapPx());
  }

  function clearForms(el) {
    if (!el || el.dataset.euFormsStackBound !== 'true') return;
    el.style.removeProperty('bottom');
    el.style.removeProperty('left');
    el.style.removeProperty('right');
    el.style.removeProperty('top');
    el.style.removeProperty('position');
    el.style.removeProperty('z-index');
    el.dataset.euFormsStackBound = 'false';
  }

  function clearWithdraw(el) {
    if (!el || el.dataset.euWithdrawStackBound !== 'true') return;
    el.style.removeProperty('bottom');
    el.style.removeProperty('left');
    el.style.removeProperty('right');
    el.dataset.euWithdrawStackBound = 'false';
  }

  function clearBxgy(el) {
    el = el || document.getElementById('bxgy-offer-root');
    if (!el || el.dataset.euBxgyStackBound !== 'true') return;
    el.style.removeProperty('bottom');
    el.style.removeProperty('top');
    el.style.removeProperty('left');
    el.style.removeProperty('right');
    el.style.removeProperty('inset');
    el.dataset.euBxgyStackBound = 'false';
  }

  function clearPromo(el) {
    if (!el || el.dataset.euPromoTeaserStackBound !== 'true') return;
    el.style.removeProperty('bottom');
    el.style.removeProperty('top');
    el.style.removeProperty('left');
    el.style.removeProperty('right');
    el.style.removeProperty('width');
    el.style.removeProperty('max-width');
    el.style.removeProperty('transform');
    el.dataset.euPromoTeaserStackBound = 'false';
  }

  function pinRight(el, rightPx) {
    if (!el) return;
    var right = rightPx == null ? '1rem' : rightPx + 'px';
    el.style.setProperty('right', right, 'important');
    el.style.setProperty('left', 'auto', 'important');
  }

  function clearAll() {
    clearForms(formsEl());
    clearWithdraw(document.querySelector('.eu-withdrawal-popup__trigger'));
    clearBxgy();
    document.querySelectorAll('.promo-teaser, .salon-locator-teaser').forEach(clearPromo);
  }

  var rafPending = false;
  var applying = false;
  var lastKey = '';

  function applyStack() {
    if (isDesignMode()) return;

    if (!hasWithdraw()) {
      lastKey = '';
      clearAll();
      return;
    }

    var mobile = isMobile();
    var inset = baseInsetPx();
    var gap = gapPx();
    var forms = formsEl();
    var withdraw = document.querySelector('.eu-withdrawal-popup__trigger');
    var bxgy = bxgyEl();
    var salon = visibleSalonTeaser();
    var promo = visiblePromoTeaser();
    /* Prefer the salon teaser for the bottom row. */
    var bottomTeaser = salon || (isSalonTeaser(promo) ? promo : null) || (mobile ? promo : null);
    /* Desktop only: same baseline beside withdraw. Mobile stacks. */
    var salonBeside = !mobile && !!bottomTeaser && isSalonTeaser(bottomTeaser);
    var stackForms = mobile && formsIsTease(forms);
    var stackTeaserBottom = !!bottomTeaser;

    var keyParts = [
      mobile ? 'm' : 'd',
      String(Math.round(inset)),
      stackForms ? '1' : '0',
      salonBeside ? 'side' : 'stack',
      stackTeaserBottom ? '1' : '0'
    ];

    if (stackForms && forms) keyParts.push('e' + Math.round(heightOf(forms)));
    if (bottomTeaser) {
      keyParts.push('t' + Math.round(heightOf(bottomTeaser)));
      keyParts.push('tw' + Math.round(widthOf(bottomTeaser)));
    }
    if (withdraw) {
      keyParts.push('w' + Math.round(heightOf(withdraw)));
      keyParts.push('ww' + Math.round(widthOf(withdraw)));
    }
    if (bxgy) keyParts.push('b' + Math.round(heightOf(bxgy)));

    var key = keyParts.join('|');
    if (key === lastKey) return;
    lastKey = key;
    applying = true;

    try {
      var cursor = inset;
      var edgeRight = (function () {
        var probe = document.createElement('div');
        probe.style.position = 'fixed';
        probe.style.right = 'var(--floating-action-edge, 2.4rem)';
        probe.style.visibility = 'hidden';
        probe.style.pointerEvents = 'none';
        document.body.appendChild(probe);
        var value = parseFloat(getComputedStyle(probe).right) || rootFontPx() * 2.4;
        document.body.removeChild(probe);
        return value;
      })();

      /*
        Bottom → top:
        1) forms tease (mobile only, if present)
        2) promo/salon teaser (bottommost; desktop: beside withdraw)
        3) withdraw (mobile: above teaser; desktop: same row as salon)
        4) BXGY above that
      */
      if (stackForms && forms) {
        forms.dataset.euFormsStackBound = 'true';
        forms.style.setProperty('position', 'fixed', 'important');
        pinRight(forms, edgeRight);
        forms.style.setProperty('top', 'unset', 'important');
        forms.style.setProperty('z-index', '950', 'important');
        forms.style.setProperty('bottom', cursor + 'px', 'important');
        cursor += heightOf(forms) + gap;
      } else {
        clearForms(forms);
      }

      if (salonBeside && bottomTeaser && withdraw) {
        /* Desktop bottom row: same baseline — [Salon] [Withdraw] */
        var rowBottom = cursor;
        withdraw.dataset.euWithdrawStackBound = 'true';
        withdraw.classList.add('mt-bottom-action-item');
        pinRight(withdraw, edgeRight);
        withdraw.style.setProperty('top', 'auto', 'important');
        withdraw.style.setProperty('bottom', rowBottom + 'px', 'important');
        withdraw.style.setProperty('transform', 'none', 'important');

        bottomTeaser.dataset.euPromoTeaserStackBound = 'true';
        bottomTeaser.classList.add('mt-bottom-action-item');
        bottomTeaser.style.setProperty('width', 'fit-content', 'important');
        bottomTeaser.style.setProperty('max-width', 'fit-content', 'important');
        bottomTeaser.style.setProperty('top', 'auto', 'important');
        bottomTeaser.style.setProperty('transform', 'none', 'important');
        /* Same bottom as withdraw — do not use the CSS “stack above chip” offset. */
        bottomTeaser.style.setProperty('bottom', rowBottom + 'px', 'important');
        pinRight(bottomTeaser, rightBesideLeftOf(withdraw));

        document.querySelectorAll('.promo-teaser, .salon-locator-teaser').forEach(function (teaser) {
          if (teaser !== bottomTeaser) clearPromo(teaser);
        });

        cursor += Math.max(heightOf(withdraw), heightOf(bottomTeaser)) + gap;
      } else {
        /* Mobile (or no side-by-side): teaser bottommost, then withdraw above it. */
        if (stackTeaserBottom && bottomTeaser) {
          bottomTeaser.dataset.euPromoTeaserStackBound = 'true';
          bottomTeaser.classList.add('mt-bottom-action-item');
          bottomTeaser.style.setProperty('width', 'fit-content', 'important');
          bottomTeaser.style.setProperty('max-width', 'fit-content', 'important');
          pinRight(bottomTeaser, edgeRight);
          bottomTeaser.style.setProperty('bottom', cursor + 'px', 'important');
          cursor += heightOf(bottomTeaser) + gap;

          document.querySelectorAll('.promo-teaser, .salon-locator-teaser').forEach(function (teaser) {
            if (teaser !== bottomTeaser) clearPromo(teaser);
          });
        } else {
          document.querySelectorAll('.promo-teaser, .salon-locator-teaser').forEach(clearPromo);
        }

        if (withdraw) {
          withdraw.dataset.euWithdrawStackBound = 'true';
          withdraw.classList.add('mt-bottom-action-item');
          pinRight(withdraw, edgeRight);
          withdraw.style.setProperty('bottom', cursor + 'px', 'important');
          cursor += heightOf(withdraw) + gap;
        }
      }

      if (bxgy) {
        bxgy.dataset.euBxgyStackBound = 'true';
        bxgy.style.setProperty('top', 'auto', 'important');
        bxgy.style.setProperty('left', 'auto', 'important');
        pinRight(bxgy, edgeRight);
        bxgy.style.setProperty('bottom', cursor + 'px', 'important');
      } else {
        clearBxgy();
      }
    } finally {
      applying = false;
    }
  }

  function scheduleStack() {
    if (rafPending || applying) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      rafPending = false;
      applyStack();
    });
  }

  function observe() {
    if (window.__euMobileStackObservers) return;
    window.__euMobileStackObservers = true;

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        scheduleStack();
      });

      function watch(el) {
        if (!el || el.dataset.euStackResizeObserved === 'true') return;
        el.dataset.euStackResizeObserved = 'true';
        ro.observe(el);
      }

      watch(formsEl());
      watch(document.querySelector('.eu-withdrawal-popup__trigger'));
      watch(document.getElementById('bxgy-offer-root'));

      new MutationObserver(function () {
        if (applying) return;
        watch(formsEl());
        watch(document.querySelector('.eu-withdrawal-popup__trigger'));
        watch(document.getElementById('bxgy-offer-root'));
        document.querySelectorAll('.promo-teaser[data-state="visible"]').forEach(watch);
        scheduleStack();
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-current-step', 'data-state', 'class', 'hidden', 'style']
      });
    }

    window.addEventListener('resize', scheduleStack);
  }

  function initStack() {
    scheduleStack();
    observe();
    if (!window.__euFormsStackInit) window.__euFormsStackInit = true;
  }

  function setLoading(trigger) {
    if (trigger.classList.contains('is-loading')) return;
    trigger.classList.add('is-loading');
    trigger.setAttribute('aria-busy', 'true');
    var spinner = trigger.querySelector('.eu-withdrawal-popup__spinner');
    if (spinner) spinner.classList.remove('hidden');
  }

  function bindPopup(root) {
    var trigger = root.querySelector('[data-eu-withdrawal-trigger]');
    if (!trigger || trigger.dataset.euWithdrawalBound === 'true') return;
    trigger.dataset.euWithdrawalBound = 'true';
    trigger.addEventListener('click', function () {
      setLoading(trigger);
    });
  }

  function boot() {
    document.querySelectorAll('[data-eu-withdrawal-popup]').forEach(bindPopup);
    if (!isDesignMode()) initStack();
  }

  window.applyEuMobileFloatingStack = scheduleStack;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var popup = event.target.querySelector('[data-eu-withdrawal-popup]');
    if (popup) {
      bindPopup(popup);
      if (!isDesignMode()) scheduleStack();
    }
  });
})();
